import { users } from '@mep/pae-commons';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';

import EntityPreview from '@/components/EntityPreview';
import { useGetOneCommercialRegister } from '@/modules/configuration/hooks/useCommercialRegister';
import { useGetOneDpjOffice } from '@/modules/configuration/hooks/useDpjOffice';
import { useGetOneHistorianOffices } from '@/modules/configuration/hooks/useHistorianOffices';
import { useGetOneNotaryOffices } from '@/modules/configuration/hooks/useNotaryOffices';

const { USER_TYPES } = users;

export const mapTitle = (text, v) => {
  return `(${v.code}) ${v.name}`;
};

const UserOfficeCell = ({ userType, ...rest }) => {
  
  const content = useMemo(() => {
    switch (userType) {
      case USER_TYPES.NOTARY_DPJ: {
        return <EntityPreview {...rest} useHook={useGetOneDpjOffice} transformTitle={mapTitle}/>;
      }
      case USER_TYPES.NOTARY: {
        return <EntityPreview {...rest} useHook={useGetOneNotaryOffices} transformTitle={mapTitle}/>;
      }
      case USER_TYPES.HISTORIAN: {
        return <EntityPreview {...rest} useHook={useGetOneHistorianOffices}/>;
      }
      case USER_TYPES.COMMERCIAL_REGISTER: {
        return <EntityPreview {...rest} useHook={useGetOneCommercialRegister}/>;
      }
      default: {
        return '-';
      }
    }
  }, [rest, userType]);
  
  return (
    <div>{content}</div>
  );
};

UserOfficeCell.propTypes = {
  value: PropTypes.string,
  userType: PropTypes.string,
};

export default memo(UserOfficeCell);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Status component in a table cell
 * @param {String} value this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} user this is the row instance
 * */
export const renderUserOfficeCell = (value, user) => {
  return (
    <UserOfficeCell value={value} user={user} defaultValue={'-'} userType={user?.userType}/>
  );
};
